import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _UBLInvoice } from "../../../../core/services/dataBean/EntityCatalog";

interface Props {
    label?: string;
    idSelect: number | null;
    onChange: Function;
}
export const SelectRemissionStateConstantsFromProductionOrder = ({ idSelect, label, onChange }: Props) => {

    const { lista, setLista, instance } = useDataBean(_UBLInvoice);
    const [id, setId] = useState<number>(NaN);

    useEffect(() => {
        instance.getRemissionStateConstantsFromProductionOrder(null).then(
            (resp: any) => {
                setLista(resp);
            }
        )
    }, [])

    useEffect(() => {
        if (idSelect != id) {
            setId(idSelect);
        }
    }, [idSelect])

    const setValue = (e: any) => {
        setId(e);
        onChange(e);
    }

    return (
        <>
            <label>{label ?? 'Estado del Documento'}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(parseInt(e.target.value)) }}>
                <option value={NaN}>...</option>
                {lista.map((item: any) => {
                    return (
                        <option value={item.DataBeanProperties.Value}>{item.DataBeanProperties.Property}</option>
                    )
                })}
            </select>
        </>
    )
}